export default __webpack_public_path__ + "static/media/Amsv2-1.a17eebd4.m4v";